/* global ArrayBuffer, Uint8Array, Promise */

'use strict';

/**
 * Initialize events
 */
function initEvents() {
    /**
     * Show select items
     */
    function showSelectItems() {
        $('.js-select-return-items').show();
        $('.js-select-return-reasons').hide();
        $('.js-select-return-payment-type').hide();
        $('.js-button-returns-back').hide();
        $('.js-button-returns-confirm').hide();
        $('.js-button-returns-next').show();
        $('.js-label-step, .js-reasons-step')
            .find('.js-progress-rectangle, .js-progress-triangle')
            .removeClass('active');
        $('.js-select-items-step')
            .find('.js-progress-rectangle, .js-progress-triangle')
            .addClass('active');
    }

    /**
     * Populate reasons element
     */
    function showReasons() {
        $('.js-select-return-items').hide();
        $('.js-select-return-payment-type').show();
        $('.js-return-label').hide();
        $('.js-button-returns-back').show();
        $('.js-button-returns-next').hide();
        $('.js-button-returns-confirm').show();
        $('.js-checkbox-return-item:not(:checked)').each(function () {
            var orderItemID = this.id;
            $('.js-reason-line[data-orderitemid="' + orderItemID + '"]').hide();
        });
        $('.js-checkbox-return-item:checked').each(function () {
            var orderItemID = this.id;
            $('.js-reason-line[data-orderitemid="' + orderItemID + '"]').show();
        });
        $('.js-select-return-reasons').show();
        $('.js-select-items-step, .js-label-step')
            .find('.js-progress-rectangle, .js-progress-triangle')
            .removeClass('active');
        $('.js-reasons-step')
            .find('.js-progress-rectangle, .js-progress-triangle')
            .addClass('active');
    }

    /**
     * Populate and show return reasons
     */
    function showReturnPaymentMethods() {
        var threshold = (!Number.isNaN($('.js-select-return-payment-type').attr('data-instacreditthreshold'))) ? parseFloat($('.js-select-return-payment-type').attr('data-instacreditthreshold')) : 300;
        var returnAmount = 0;
        var $instaCreditReturn = $('.js-instacredit-return');
        $('.js-checkbox-return-item:checked').each(function () {
            var $this = $(this);
            var adjustedPrice = (!Number.isNaN($this.attr('data-adjustedprice'))) ? parseFloat($this.attr('data-adjustedprice')) : 0;
            var adjustedTax = (!Number.isNaN($this.attr('data-adjustedtax'))) ? parseFloat($this.attr('data-adjustedtax')) : 0;
            returnAmount += adjustedPrice + adjustedTax;
        });

        $instaCreditReturn.find('input[type="checkbox"]').prop('checked', false);

        if ($instaCreditReturn.length > 0 && returnAmount < threshold) {
            $('.js-select-return-payment-type').addClass('allow-instacredit');
        } else {
            $('.js-select-return-payment-type').removeClass('allow-instacredit');
        }
    }

    /**
     * Display label
     */
    function showLabel() {
        $('.js-select-return-reasons').hide();
        $('.js-select-return-payment-type').hide();
        $('.js-button-returns-next').hide();
        $('.js-button-returns-back').hide();
        $('.js-button-returns-confirm').hide();
        // $('.js-return-label').show();
        $('.js-select-items-step, .js-reasons-step')
            .find('.js-progress-rectangle, .js-progress-triangle')
            .removeClass('active');
        $('.js-label-step')
            .find('.js-progress-rectangle')
            .addClass('active');
    }

    /**
     * Hanle select items
     */
    function handleSelectItems() {
        var $selectedItems = $('.js-checkbox-return-item:checked');
        if ($selectedItems.length) {
            showReasons();
            showReturnPaymentMethods();
        } else {
            $('.invalid-feedback.returns-invalid').show();
        }
    }
    /**
     * Checks image if image upload is valid and clears/marks the image input
     * @param {DOM} photoInput - Image file input for return reason photo
     * @param {DOM} warningMsg - Warning message if uploaded file is invalid
     * @returns {void} - If photo input has warning message - clears the file input,
     * and if it hasn't - marks the input as uploaded and
     * show image preview and file name in the upload tab
     */
    function reasonImageCheck(photoInput, warningMsg) {
        var $fileInputForm = $(photoInput).parents('.form-group');
        if (warningMsg && warningMsg === 'NoInput') {
            $(photoInput).val('').removeClass('uploaded');
            $fileInputForm.find('.js-upload-reason-photo').removeClass('d-none').addClass('d-flex');
            $fileInputForm.find('.uploaded-file-name').text('');
            $fileInputForm.find('img').addClass('d-none').attr('src', '#');
            $fileInputForm.find('.js-remove-reason-photo').addClass('d-none');
        } else if (warningMsg) {
            $(photoInput).val('').removeClass('uploaded');
            $fileInputForm.find('.uploaded-file-name').addClass('text-danger').text(warningMsg);
            $fileInputForm.find('img').addClass('d-none').attr('src', '');
            $fileInputForm.find('.js-remove-reason-photo').addClass('d-none');
            $fileInputForm.find('.js-upload-reason-photo').removeClass('d-none').addClass('d-flex');
        } else {
            $(photoInput).addClass('uploaded');
            // var filename = $(photoInput).val().split('\\').pop();
            $fileInputForm.find('.uploaded-file-name').removeClass('text-danger').text('');
            $fileInputForm.find('img').removeClass('d-none').attr('src', URL.createObjectURL(photoInput.files[0]));
            $fileInputForm.find('.js-remove-reason-photo').removeClass('d-none');
            $fileInputForm.find('.js-upload-reason-photo').removeClass('d-flex').addClass('d-none');
        }
    }

    /**
     * Converts dataUrl to Blob
     * @param {string} dataURL - data url
     * @returns {Blob} blob
     */
    function dataURLToBlob(dataURL) {
        var BASE64_MARKER = ';base64,';
        var parts;
        var contentType;
        var raw;
        if (dataURL.indexOf(BASE64_MARKER) === -1) {
            parts = dataURL.split(',');
            contentType = parts[0].split(':')[1];
            raw = parts[1];
            return new Blob([raw], {
                type: contentType
            });
        }
        parts = dataURL.split(BASE64_MARKER);
        contentType = parts[0].split(':')[1];
        raw = window.atob(parts[1]);
        var rawLength = raw.length;

        var uInt8Array = new Uint8Array(rawLength);

        // eslint-disable-next-line no-plusplus
        for (var i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
            type: contentType
        });
    }

    /**
     * Resizes uploaded image filre to given scale
     * @param {File} file - uploaded image file
     * @param {number} scale - maximum width/height (dependent on image layout - portrait or landscape)
     * @returns {File} imagefile
     */
    async function resizeImage(file, scale) {
        return new Promise(function (resolve) {
            var formData = new FormData();
            var imageFile = file;
            var reader = new FileReader();
            reader.onload = function (e) {
                var img = document.createElement('img');
                img.onload = function () {
                    var canvas = document.createElement('canvas');
                    var width = img.width;
                    var height = img.height;
                    if (width > height) {
                        if (width > scale) {
                            height *= scale / width;
                            width = scale;
                        }
                    } else if (height > scale) {
                        width *= scale / height;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(img, 0, 0, width, height);
                    var dataurl = canvas.toDataURL(imageFile.type);
                    var blub = dataURLToBlob(dataurl);
                    formData.append('upload', blub, file.name);
                    resolve(formData);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(imageFile);
        });
    }
    /**
     * Upload image files for each return reason requiring photo
     * @param {DOM} reasonLines - Selected product lines to return in reasons section
     * @returns {boolean} result - Returns true/false if all images are uploaded successfully
     */
    function uploadReasonImages(reasonLines) {
        var result = false;
        var $reasonLinesWithPhotoRequired = $(reasonLines).has('.js-sub-reason.active option[photorequired]:selected');
        if (!$reasonLinesWithPhotoRequired.find('.js-reason-photo-input:not(.uploaded)').length) {
            result = true;
            var $reasonSelectors = $(reasonLines).find('.js-sub-reason.active');
            $reasonSelectors.each(async function (index, reasonSelector) {
                var $that = $(this);
                var $photoReason = $(reasonSelector).find('[photorequired]:selected');
                var $reasonPhotoForm = $(reasonSelector).siblings('.return-photo').find('.returns-reasonphoto-form');
                if ($photoReason.length && $reasonPhotoForm.find('.js-reason-photo-input').val() !== '') {
                    var url = $reasonPhotoForm.data('action');
                    var $reasinPhotoFileInput = $reasonPhotoForm.find('.js-reason-photo-input');
                    var scale = parseFloat($reasinPhotoFileInput.attr('data-imagescale')).toFixed(0);
                    var file = $reasinPhotoFileInput.get(0);
                    var resizedImageFormData = await resizeImage(file.files[0], scale);
                    $.ajax({
                        url: url,
                        async: false,
                        type: 'POST',
                        dataType: 'json',
                        data: resizedImageFormData,
                        cache: false,
                        processData: false,
                        contentType: false
                    }).done(function (response) {
                        if (response.success) {
                            $reasonPhotoForm.find('.uploaded-file-name').removeClass('text-danger');
                            $that.attr('data-photo-path', response.filePath);
                        } else {
                            $reasonPhotoForm.find('.uploaded-file-name').addClass('text-danger').text(response.msg);
                            $reasonPhotoForm.find('.js-reason-photo-input').val('');
                            result = false;
                        }
                    });
                }
            });
        } else {
            var $fileNameLabel = $reasonLinesWithPhotoRequired.has('.js-reason-photo-input:not(.uploaded)').find('.uploaded-file-name');
            $fileNameLabel.removeClass('d-none').addClass('text-danger').text($fileNameLabel.attr('data-unuploaded-msg'));
        }
        return result;
    }

    /**
     * Get return label
     */
    function displayReturnLabel() {
        $(document).ready(function () {
            if ($('#approved-return-case-data').length > 0) {
                showLabel();
                var dataItem = $('#approved-return-case-data');
                var labelBase64src = 'data:application/pdf;base64,' + dataItem.data('alllabels').split(',')[0];
                labelBase64src = labelBase64src.replace(/\r?\n|\r/g, '');
                $('.return-label-download').attr('href', labelBase64src);
                $('.sample-label-image').show();
            }
        });
    }
    displayReturnLabel();

    /**
     * Get selected items
     * @returns {Object} items
     */
    function getSelectedItems() {
        return $('.js-reason-line:visible')
            .filter(function () {
                var $this = $(this);
                var reasonCode = $this.find('.js-reason').val();
                if (!reasonCode || reasonCode === 'not-selected') {
                    return false;
                }
                var subReasonEl = $this.find('.js-sub-reason:visible');
                if (subReasonEl.length !== 1) {
                    return false;
                }
                return subReasonEl.val();
            })
            .map(function () {
                var $this = $(this);
                return {
                    productID: $this.data('itemid'),
                    productName: $this.data('productname'),
                    orderItemID: $this.data('orderitemid'),
                    productPrice: $this.data('price'),
                    productWeight: $this.data('weight'),
                    UUID: $this.data('pliuuid'),
                    reason: {
                        id: $this.find('.js-reason').val(),
                        value: $this.find('.js-reason').find('option:selected').data('displayname'),
                        reasonPhotoFilePath: $this.find('.js-sub-reason.active').attr('data-photo-path')
                    },
                    subReason: {
                        id: $this.find('.js-sub-reason:visible').val(),
                        value: $this.find('.js-sub-reason:visible').find('option:selected').html()
                    },
                    quantity: $this.find('.js-return-quantity').val()
                };
            })
            .get();
    }

    /**
     * Returns if instaCredit is checked
     * @returns {boolean} is checked
     */
    function getInstaCreditOptIn() {
        return $('.js-instacredit-return').find('input[type="checkbox"]:checked').length > 0;
    }

    /**
     * Handle selected reasons dropdown
     */
    function handleSelectReasons() {
        $('body').spinner().start();

        var $submitReturnLabelBtn = $('.js-button-returns-next');
        var url = $submitReturnLabelBtn.data('url');
        var returnsHandler = $submitReturnLabelBtn.data('returnshandler');
        var returnMethodId = $submitReturnLabelBtn.attr('data-returnmethodid');
        var orderID = $submitReturnLabelBtn.data('orderid');
        var $selectedLineItems = $('.js-reason-line:visible');
        var notSelectedReasons = $selectedLineItems.find('.js-reason option[class="not-selected"]:selected');
        var notSelectedSubReasons = $selectedLineItems.find('.js-sub-reason.active option[class="not-selected"]:selected');
        if (!notSelectedReasons.length && !notSelectedSubReasons.length) {
            var uploadedReasonPhotos = uploadReasonImages($selectedLineItems);
            if (uploadedReasonPhotos) {
                var items = getSelectedItems();

                if (items.length !== $selectedLineItems.length) {
                    $('.label-error').show();
                    $('body').spinner().stop();
                }

                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: url,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        items: items,
                        orderID: orderID,
                        optInInstaCredit: getInstaCreditOptIn(),
                        returnMethodId: returnsHandler.id !== 'sfcc' ? returnMethodId : 'sfcc'
                    })
                })
                    .done(function (response) {
                        if (response && response.upsValidationError && items.length > 0) {
                            $('body').spinner().stop();
                            $('.ups-validation-error').show();
                            return;
                        }

                        if (!response || response.success === false) {
                            $('body').spinner().stop();
                            $('.return-processing-error').show();

                            // Deselect checkboxes
                            $('.js-checkbox-return-item').prop('checked', false);

                            // Deselect return reasons
                            $('.js-sub-reason-fit-issues :selected').prop('selected', false);
                            $('.return-reason-selector :selected').prop('selected', false);
                            $('.return-reason-selector').trigger('change');

                            // Show initial select screen
                            showSelectItems();

                            return;
                        }

                        var newurl = window.location.href;
                        if (newurl.indexOf('?id=') === -1) {
                            newurl = newurl + '?id=' + response.returnObject.id;
                        }
                        $('#returnMethodsModal').modal('hide');
                        window.history.pushState({
                            path: newurl
                        }, '', newurl);
                        if (response.returnsRequireApproval) {
                            $('.display-return-label').html(
                                '<h1>Thank you for your request</h1>'
                                + '<p>Our customer service team have received your request.</br>'
                                + 'Once your return is approved you will receive an email with</br> a link to download a shipping label.</p>'
                            );
                            $('.js-button-returns-back').hide();
                            $('.display-return-label').show();
                            $('body').spinner().stop();
                            // eslint-disable-next-line consistent-return
                            return showLabel();
                        }
                        var returnLines = response.returnGroups || response.returnLines;
                        $('.return-heading .totalLocations').text(returnLines.length);
                        $('.return-heading').removeClass('d-none');
                        $('.actions').addClass('d-none');
                        var i = 1;
                        returnLines.forEach(function (ret) {
                            var retLines = ret.returnLines;
                            var $rtLblDisplay = $('.return-labels');
                            if ($rtLblDisplay.length > 0) {
                                $rtLblDisplay.append('<h4 class="return-label-count">Return ' + i + ' of ' + returnLines.length + '</h4>');
                            }
                            var combinedLabel = ret.combinedLabel || false;

                            // no combined label in response, so triggering it manually here for showing combined label button under return item
                            if (response.returnHandler === 'zkapi') {
                                combinedLabel = true;
                            }

                            var combinedLabelPrinted = false;
                            retLines.forEach(function (retLine) {
                                var $retLbl = $('.return-label-template').clone();
                                $retLbl.removeClass('return-label-template');

                                var labelBase64src = '';
                                var labeltype = '';

                                $('body').spinner().stop();
                                if (response.error) {
                                    throw new Error('Unable to get label');
                                }

                                // Set product attributes
                                $('.line-item-name', $retLbl).html(retLine.productName);
                                $('.line-item-image img', $retLbl).attr('src', retLine.productImage);
                                $('.item-data', $retLbl).html(retLine.renderedTemplate);
                                var qty = retLine.quantity !== '' ? retLine.quantity : '1';
                                $('.line-item-attributes.quantity', $retLbl).html($('.line-item-attributes.quantity', $retLbl).data('label') + qty);
                                $retLbl.show();

                                if (!combinedLabelPrinted) {
                                    labeltype = retLine.labelType.toLowerCase();

                                    if (labeltype === 'pdf') {
                                        labelBase64src = 'data:application/pdf;base64,' + retLine.label;
                                        labelBase64src = labelBase64src.replace(/\r?\n|\r/g, '');
                                        $('.sample-label-image', $retLbl).show();
                                    } else {
                                        labelBase64src = 'data:image/' + labeltype + ';base64,' + retLine.label;
                                        $('.label-image img', $retLbl).attr('src', labelBase64src);
                                    }
                                    $('.return-label-download', $retLbl).attr('href', labelBase64src);
                                    $('.action-container', $retLbl).show();
                                    if (combinedLabel) {
                                        combinedLabelPrinted = true;
                                        var $retLblComb = $('.return-label-combined');
                                        $retLblComb.show();
                                        $('.return-label-download', $retLblComb).attr('href', labelBase64src);
                                        $('.action-container', $retLbl).hide();
                                    }
                                }
                                showLabel();
                                $('.return-labels').append($retLbl);
                            });
                            // eslint-disable-next-line no-plusplus
                            i++;
                        });
                        $('body').spinner().stop();
                    }).fail(function () {
                        $('body').spinner().stop();
                        $('.ups-validation-error').show();
                    });
            } else {
                $('body').spinner().stop();
            }
        } else {
            $('.invalid-feedback.reasons-invalid').show().text($('.invalid-feedback.reasons-invalid').attr('data-select-reasons-msg'));
            $('body').spinner().stop();
        }
    }

    /**
     * Get avaliable return methods from ZKAPI returns handler
     * @param {JQuery} element - html element containing data for return
     */
    function getReturnMethods(element) {
        var $returnMethodsModal = $('#returnMethodsModal');
        $returnMethodsModal.find('.returns-dropoff-map').addClass('d-none');
        var orderID = $(element).data('orderid');
        var returnsHandler = $(element).data('returnshandler');
        var items = getSelectedItems();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: returnsHandler.url,
            contentType: 'application/json',
            data: JSON.stringify({
                items: items,
                orderID: orderID,
                optInInstaCredit: getInstaCreditOptIn()
            })
        }).done(function (response) {
            $('.js-select-return-reasons').spinner().stop();
            if (response && response.error && response.error === 'Wrong request') {
                $('.invalid-feedback.reasons-invalid').show();
            } else if (response && response.returnMethods && response.returnMethods.length) {
                if (response.returnMethods.length === 1) {
                    if (response.returnMethods[0].type === 'drop_off') {
                        sessionStorage.nearestLocation = JSON.stringify(response.returnMethods[0].options[0]);
                    }
                    $('.js-button-returns-next').attr('data-returnmethodid', response.returnMethods[0].options[0].id);
                    handleSelectReasons();
                } else {
                    var returnMethods = response.returnMethods;
                    $returnMethodsModal.modal('show');
                    var returnMethodsOptions = '';
                    returnMethods.forEach(function (returnMethod) {
                        if (returnMethod.type === 'drop_off') {
                            sessionStorage['return-method-' + returnMethod.id] = JSON.stringify(returnMethod.options);
                        }
                        returnMethodsOptions += returnMethod.renderedOptionTemplate;
                    });
                    $returnMethodsModal.find('.return-options').html(returnMethodsOptions);
                }
            } else {
                $('body').spinner().stop();
                $('.ups-validation-error').show();
            }
        }).fail(function () {
            $('body').spinner().stop();
            $('.ups-validation-error').show();
        });
    }

    // eslint-disable-next-line valid-jsdoc
    /**
     * Check if browser is safari
     */
    function isSafari() {
        return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
    }
    /**
     * Initialize the download button
     */
    function initDownloadButton() {
        $(document).on('click', '.return-label-download', function (e) {
            e.preventDefault();
            var pdf = $(this).attr('href');
            pdf = pdf.replace('data:application/pdf;base64,', '');
            var binary = atob(pdf.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i += 1) {
                view[i] = binary.charCodeAt(i);
            }

            // Create the blob object with content-type "application/pdf"
            var blob = new Blob([view], { type: 'application/pdf' });
            var url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    }

    $(document).on('click', '.zkapi-return-label-download', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.ajax({
            method: 'POST',
            url: url,
            data: {
                returnId: $(this).data('returnid')
            },
            success: function (response) {
                var labelBase64src = response.label;
                var binary = atob(labelBase64src.replace(/\s/g, ''));
                var len = binary.length;
                var buffer = new ArrayBuffer(len);
                var view = new Uint8Array(buffer);
                // eslint-disable-next-line no-plusplus
                for (var i = 0; i < len; i++) {
                    view[i] = binary.charCodeAt(i);
                }

                // Create the blob object with content-type "application/pdf"
                var blob = new Blob([view], { type: 'application/pdf' });

                var link = document.createElement('a');
                // create a blobURL pointing to our Blob
                link.href = URL.createObjectURL(blob);
                link.download = 'return-label';
                // some browser needs the anchor to be in the doc
                document.body.append(link);
                link.click();
                link.remove();
            }
        });
    });

    $(document).on('click', '.js-button-returns-next, .js-button-returns-confirm', function () {
        $('.invalid-feedback').hide();
        $('.ups-validation-error').hide();
        $('.return-processing-error').hide();
        if ($('.js-select-return-items').is(':visible')) {
            handleSelectItems();
        } else {
            $('.js-select-return-reasons').spinner().start();
            var returnsHandler = $(this).data('returnshandler');
            if (returnsHandler.id !== 'sfcc') {
                if ($('#instaCreditReturnPaymentTypeCheckbox')) {
                    $(document).trigger('return-type:change', 'instacredit');
                }
                getReturnMethods($(this));
            } else {
                $('body').spinner().stop();
                handleSelectReasons();
            }
        }
    });
    $(document).on('click', '.js-button-returns-back', function () {
        $('.invalid-feedback').hide();
        $('.ups-validation-error').hide();
        if ($('.js-return-label').is(':visible')) {
            showReasons();
        } else {
            showSelectItems();
        }
    });

    $(document).off('change', '.return-reason-selector').on('change', '.return-reason-selector', function () {
        var $lineItem = $(this).closest('.js-reason-line');
        $lineItem.find('.js-sub-reason.active')
            .removeClass('active')
            .hide();
        var selectedReason = $(this).val();
        var $selectedReasonEl = $lineItem.find('.js-sub-reason-' + selectedReason);
        $selectedReasonEl.addClass('active').show();
        var photoRequired = $lineItem.find('.js-sub-reason-' + selectedReason).find(':selected').is('[photoRequired]');
        if (photoRequired) {
            $lineItem.find('.return-photo').removeClass('d-none');
        } else {
            $lineItem.find('.return-photo').addClass('d-none');
            var reasoninput = $lineItem.find('.return-photo .js-reason-photo-input');
            reasonImageCheck(reasoninput, 'NoInput');
        }
        $('.invalid-feedback').hide();
    });
    $(document).off('change', '.js-sub-reason').on('change', '.js-sub-reason', function () {
        var $lineItem = $(this).closest('.js-reason-line');
        $(this).addClass('active').show();
        var photoRequired = $(this).find(':selected').is('[photoRequired]');
        if (photoRequired) {
            $lineItem.find('.return-photo').removeClass('d-none');
        } else {
            $lineItem.find('.return-photo').addClass('d-none');
            var reasoninput = $lineItem.find('.return-photo .js-reason-photo-input');
            reasonImageCheck(reasoninput, 'NoInput');
        }
        $('.invalid-feedback').hide();
    });

    $(document).on('click', '.js-instacredit-return input[type="checkbox"]', function () {
        $('.invalid-feedback').hide();
    });

    $(document).on('click', '.line-item', function () {
        var checkbox = $(this).find('input[type="checkbox"]');
        if (checkbox.prop('checked')) {
            checkbox.prop('checked', false);
        } else {
            checkbox.prop('checked', true);
        }
    });

    $(document).on('click', '.update-order-btn', function (e) {
        e.preventDefault();
        var $missingDataForm = $('.missingData-form');
        var missingEmail = $missingDataForm.find('input[name="missing-email"]').val();
        var missingAddress = $missingDataForm.find('input[name="missing-address"]').val();
        var missingPhone = $missingDataForm.find('input[name="missing-phone"]').val() || null;
        var missingPostCode = $missingDataForm.find('input[name="missing-postcode"]').val() || null;
        var orderId = $missingDataForm.attr('data-orderid');
        var url = $missingDataForm.attr('data-url');
        var missingData = {
            email: missingEmail,
            address: missingAddress,
            phone: missingPhone,
            postcode: missingPostCode
        };

        $.ajax({
            method: 'POST',
            url: url,
            data: {
                orderId: orderId,
                missingData: JSON.stringify(missingData)
            },
            success: function (response) {
                if (response.status === 'Success') {
                    window.location.reload();
                } else {
                    response.arguments.forEach(function (arg) {
                        var warningSpan = $missingDataForm.find('input[name="missing-' + arg.argument + '"]').siblings('span.invalid-' + arg.argument + '');
                        warningSpan.text(arg.message);
                    });
                }
            },
            error: function (ex) {
                // eslint-disable-next-line no-alert
                alert(ex);
            }
        });
    });

    $(document).on('change', '.js-reason-photo-input', function () {
        if ($(this).val() !== '') {
            var fileSize = this.files[0].size / 1024; // Gets file size in KBs
            var fileFormat = this.files[0].type;
            var maxFileSize = $(this).attr('data-maxfilesize');
            var warningMsg = '';
            if (fileSize >= maxFileSize) {
                warningMsg = $(this).attr('data-maxfilesize-warning-msg');
                reasonImageCheck(this, warningMsg);
            } else if (!fileFormat.includes('image/')) {
                warningMsg = $(this).attr('data-fileformat-warning-msg');
                reasonImageCheck(this, warningMsg);
            } else {
                reasonImageCheck(this, null);
            }
        } else {
            reasonImageCheck(this, 'NoInput');
        }
    });
    $(document).on('click', '.js-remove-reason-photo', function () {
        var reasoninput = $(this).parents('.returns-reasonphoto-form').find('.js-reason-photo-input');
        reasonImageCheck(reasoninput, 'NoInput');
    });
    $(document).ready(function () {
        if (isSafari()) {
            initDownloadButton();
        }
    });
}

$(document).ready(function () {
    initEvents();
});
